var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        top: "5vh",
        width: "80%",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c(
            "el-row",
            [
              _c("span", { staticClass: "dialog-title-text" }, [
                _vm._v("调价设置"),
              ]),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "商城售价以猫眼，淘票票售价为基准浮动",
                    placement: "right",
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-alert__icon el-icon-warning",
                    staticStyle: { color: "#f56c6c" },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "dialog-title-con" }, [
        _c("i", {
          staticClass: "el-alert__icon el-icon-warning",
          staticStyle: { color: "#f56c6c" },
        }),
        _vm._v(
          " 商城售价=市场价*(1+调整比例) 例:市场价=100,调整比例=1%,商城售价=100(1+1%)=101.00 "
        ),
      ]),
      _c(
        "el-form",
        {
          ref: "setFormRule",
          staticStyle: { margin: "10px 0" },
          attrs: {
            model: _vm.setFormRule,
            "label-position": "left",
            inline: true,
            size: "small",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    label: "调价规则名称",
                    "label-width": "120px",
                    prop: "rule_name",
                    rules: {
                      required: true,
                      message: "调价规则不能为空",
                    },
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "157px" },
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.setFormRule.rule_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.setFormRule, "rule_name", $$v)
                      },
                      expression: "setFormRule.rule_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    "label-width": "90px",
                    label: "调价方式",
                    prop: "adjust_type",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "请选择调价方式",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.setFormRule.adjust_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.setFormRule, "adjust_type", $$v)
                        },
                        expression: "setFormRule.adjust_type",
                      },
                    },
                    [
                      _c("el-checkbox", { key: "1", attrs: { label: "1" } }, [
                        _vm._v("按比例浮动"),
                      ]),
                      _c("el-checkbox", { key: "2", attrs: { label: "2" } }, [
                        _vm._v("按金额浮动"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _vm.priceType == "all" || _vm.priceType == "ratio"
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1" },
                      attrs: {
                        label: "调价比例(%)",
                        "label-width": "120px",
                        prop: "by_ratio_adjust",
                        rules: [
                          { required: true, message: "请输入调价比例" },
                          {
                            pattern: /^(-|\+)?\d+(\.\d{1,2})?$/,
                            message: "请填写数字格式，仅限两位小数",
                          },
                          {
                            validator: function (rule, value, callback) {
                              if (!value) {
                                return callback()
                              }
                              // 计算最终折扣：100% + 调价比例（负数表示降价）
                              var finalDiscount = 100 + parseFloat(value)
                              // 允许的最小折扣是配置的预警值
                              var minDiscount = this$1.warning_restrictions
                              if (finalDiscount < minDiscount) {
                                return callback(
                                  "折扣不可低于" +
                                    minDiscount +
                                    "，请重新输入！"
                                )
                              }
                              callback()
                            },
                            trigger: ["input", "change", "blur"],
                          },
                        ],
                      },
                    },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c(
                          "span",
                          {
                            style: {
                              color:
                                _vm.setFormRule.by_ratio_adjust &&
                                100 + Number(_vm.setFormRule.by_ratio_adjust) <
                                  _vm.warning_restrictions
                                  ? "red"
                                  : "",
                            },
                          },
                          [_vm._v("调价比例(%)")]
                        ),
                      ]),
                      _c("el-input", {
                        staticStyle: { width: "157px" },
                        attrs: { placeholder: "加10%，请输入10" },
                        model: {
                          value: _vm.setFormRule.by_ratio_adjust,
                          callback: function ($$v) {
                            _vm.$set(_vm.setFormRule, "by_ratio_adjust", $$v)
                          },
                          expression: "setFormRule.by_ratio_adjust",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.priceType == "all" || _vm.priceType == "money"
                ? _c(
                    "el-form-item",
                    {
                      staticStyle: { flex: "1" },
                      attrs: {
                        label: "调整金额",
                        "label-width": "90px",
                        prop: "by_money_adjust",
                        rules: [
                          { required: true, message: "请输入调整金额" },
                          ,
                          {
                            pattern: /^((-|\+)?\d+)\.?(\d{0,2})$/,
                            message: "请填写数字格式，仅限两位小数",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "157px" },
                        attrs: { placeholder: "售价=标准售价+调整金额" },
                        model: {
                          value: _vm.setFormRule.by_money_adjust,
                          callback: function ($$v) {
                            _vm.$set(_vm.setFormRule, "by_money_adjust", $$v)
                          },
                          expression: "setFormRule.by_money_adjust",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: {
                    label: "划线价",
                    prop: "is_show_line_price",
                    "label-width": "120px",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "请选择划线价",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.setFormRule.is_show_line_price,
                        callback: function ($$v) {
                          _vm.$set(_vm.setFormRule, "is_show_line_price", $$v)
                        },
                        expression: "setFormRule.is_show_line_price",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("隐藏"),
                      ]),
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("显示"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "title",
                      staticStyle: { "margin-left": "5px" },
                    },
                    [_vm._v("市场价作为划线价")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              { staticStyle: { flex: "1" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      "label-width": "120px",
                      label: "是否设置生效时间",
                      prop: "is_set_timing",
                      rules: [
                        {
                          required: true,
                          trigger: "change",
                          message: "请选择是否设置生效时间",
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.setFormRule.is_set_timing,
                          callback: function ($$v) {
                            _vm.$set(_vm.setFormRule, "is_set_timing", $$v)
                          },
                          expression: "setFormRule.is_set_timing",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                        _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "title" }, [
                      _vm._v(
                        " 选择【是】时，仅按设置的时间段及周期生效；选择【否】时，设置规则后立即生效； "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm.setFormRule.is_set_timing == 1
                  ? _c(
                      "el-form-item",
                      {
                        staticClass: "day-wrap",
                        attrs: {
                          label: "生效周期",
                          "label-width": "120px",
                          prop: "dayValue",
                          rules: [
                            {
                              required: true,
                              validator: function (rule, value, callback) {
                                if (!value || value.length === 0) {
                                  callback(new _vm.Error("请选择生效周期"))
                                } else {
                                  callback()
                                }
                              },
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.setFormRule.dayValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.setFormRule, "dayValue", $$v)
                              },
                              expression: "setFormRule.dayValue",
                            },
                          },
                          _vm._l(_vm.days, function (item, index) {
                            return _c(
                              "el-checkbox",
                              { key: index, attrs: { label: item.id } },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm.setFormRule.is_set_timing == 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "生效时间段",
                    "label-width": "120px",
                    prop: "time_type",
                    rules: [
                      {
                        required: true,
                        trigger: "change",
                        message: "请选择生效时间段",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.setFormRule.time_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.setFormRule, "time_type", $$v)
                        },
                        expression: "setFormRule.time_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("全天（0~24点）"),
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v("指定时间段"),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(" 注意：选中的调价时间段有叠加，系统将自动合并！ "),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.setFormRule.time_type == 2 && _vm.setFormRule.is_set_timing == 1
            ? _c(
                "el-form-item",
                { staticClass: "time-wrap", attrs: { "label-width": "120px" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" 指定时间段 "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "time-box" },
                    [
                      _vm._l(_vm.times, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "5px" },
                          },
                          [
                            _c("el-time-picker", {
                              attrs: {
                                "is-range": "",
                                "value-format": "HH:mm:ss",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                placeholder: "选择时间范围",
                                clearable: false,
                              },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            }),
                            _vm.times.length > 1
                              ? _c("el-button", {
                                  staticStyle: {
                                    "margin-left": "5px",
                                    "font-size": "16px",
                                  },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delTime(index)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { margin: "5px 0", "font-size": "13px" },
                          attrs: { type: "text" },
                          on: { click: _vm.addTime },
                        },
                        [_vm._v("+添加时间段")]
                      ),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _c("br"),
        ],
        1
      ),
      _vm.ruleType == "1"
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "客户范围", name: "custom" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "影院范围", name: "cinema" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName == "custom" && (_vm.ruleType == "1" || _vm.ruleType == "2")
        ? _c(
            "el-form",
            {
              staticClass: "home__search",
              attrs: { data: _vm.customForm, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户ID" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.customForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.customForm, "id", $$v)
                      },
                      expression: "customForm.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户名称" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.customForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.customForm, "name", $$v)
                      },
                      expression: "customForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.searchCustom("custom")
                        },
                      },
                    },
                    [_vm._v("查 询")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName == "custom" && (_vm.ruleType == "1" || _vm.ruleType == "2")
        ? _c("div", { staticClass: "custom-style" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("h3", { staticStyle: { margin: "5px 0" } }, [
                  _vm._v("待选客户"),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticStyle: { height: "400px", "overflow-y": "auto" },
                    attrs: {
                      border: "",
                      stripe: true,
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      align: "center",
                      data: _vm.customList,
                    },
                    on: {
                      "selection-change": function (res) {
                        return _vm.handleSelectionCustom(res, "custom")
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        selectable: _vm.selectableCustom,
                        width: "35",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "客户ID", width: "80px", prop: "id" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "客户名称", prop: "company_name" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "center" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "0" },
                    attrs: {
                      type: "primary",
                      icon: "el-icon-arrow-right",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.batchAddCustom("custom")
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "margin-left": "-5px",
                        },
                      },
                      [_vm._v("添加")]
                    ),
                  ]
                ),
                _vm.checkedDelCustom.length
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { margin: "0" },
                        attrs: {
                          type: "warning",
                          icon: "el-icon-arrow-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchDel("custom")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "10px",
                              "margin-left": "-5px",
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("h3", [_vm._v("已选客户")]),
                _c(
                  "el-table",
                  {
                    staticStyle: { height: "400px", "overflow-y": "auto" },
                    attrs: {
                      border: "",
                      stripe: true,
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      align: "center",
                      data: _vm.checkedCustomList,
                    },
                    on: {
                      "selection-change": function (res) {
                        return _vm.handleCheckedDelCustom(res, "custom")
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "35" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "客户ID", width: "80px", prop: "id" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "客户名称", prop: "company_name" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.activeName == "custom" && (_vm.ruleType == "1" || _vm.ruleType == "2")
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "left",
                "margin-top": "10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                key: "custom",
                attrs: {
                  background: "",
                  "page-sizes": [20, 50, 200],
                  layout: "total, prev, pager, next, sizes",
                  "page-size": 20,
                  total: _vm.pages.totalCount,
                },
                on: {
                  "size-change": function (res) {
                    return _vm.sizeChange(res, "custom")
                  },
                  "current-change": function (res) {
                    return _vm.onChange(res, "custom")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName == "cinema" && (_vm.ruleType == "1" || _vm.ruleType == "3")
        ? _c(
            "el-form",
            {
              staticClass: "home__search",
              attrs: { data: _vm.cinemaForm, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "影院编码" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.cinemaForm.standard_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.cinemaForm, "standard_id", $$v)
                      },
                      expression: "cinemaForm.standard_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "影院名称" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: _vm.cinemaForm.cinema_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.cinemaForm, "cinema_name", $$v)
                      },
                      expression: "cinemaForm.cinema_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.searchCustom("cinema")
                        },
                      },
                    },
                    [_vm._v("查 询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.batchAddCustom("cinema")
                        },
                      },
                    },
                    [_vm._v("批量添加")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName == "cinema" && (_vm.ruleType == "1" || _vm.ruleType == "3")
        ? _c("div", { staticClass: "custom-style" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("h3", [_vm._v("待选影院")]),
                _c(
                  "el-table",
                  {
                    key: _vm.tableKey,
                    ref: "multipleTable",
                    staticStyle: { height: "400px", overflow: "auto" },
                    attrs: {
                      border: "",
                      stripe: true,
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      align: "center",
                      data: _vm.cinemaList,
                    },
                    on: {
                      "selection-change": function (res) {
                        return _vm.handleSelectionCustom(res, "cinema")
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        selectable: _vm.selectableCinema,
                        width: "35",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "影院编码",
                        width: "80px",
                        prop: "standard_id",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "影院名称", prop: "cinema_name" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "center" },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { margin: "0" },
                    attrs: {
                      type: "primary",
                      icon: "el-icon-arrow-right",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.batchAddCustom("cinema")
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          "margin-left": "-5px",
                        },
                      },
                      [_vm._v("添加")]
                    ),
                  ]
                ),
                _vm.checkedDelCinema.length
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { margin: "0" },
                        attrs: {
                          type: "warning",
                          icon: "el-icon-arrow-left",
                          circle: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.batchDel("cinema")
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "10px",
                              "margin-left": "-5px",
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("h3", [_vm._v("已选影院")]),
                _c(
                  "el-table",
                  {
                    staticStyle: { height: "400px", overflow: "auto" },
                    attrs: {
                      border: "",
                      stripe: true,
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      align: "center",
                      data: _vm.checkedCinemaList,
                    },
                    on: {
                      "selection-change": function (res) {
                        return _vm.handleCheckedDelCustom(res, "cinema")
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "35" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "影院编码",
                        width: "80px",
                        prop: "standard_id",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "影院名称", prop: "cinema_name" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.activeName == "cinema" && (_vm.ruleType == "1" || _vm.ruleType == "3")
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "left",
                "margin-top": "10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                key: "cinema",
                attrs: {
                  background: "",
                  "page-sizes": [20, 50, 200],
                  layout: "total, prev, pager, next, sizes",
                  "page-size": 20,
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": function (res) {
                    return _vm.sizeChange(res, "cinema")
                  },
                  "current-change": function (res) {
                    return _vm.onChange(res, "cinema")
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.editSubmitAdjust } },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }